export const EventGroups = {
    userActions: 'user_actions',
};

export const EventTypes = {
    clickedOnTranslationButton: 'clickedOnTranslationButton',
    clickedOnCancelledTranslationButton: 'clickedOnCancelledTranslationButton',
};
